module.exports = __webpack_public_path__ + "img/Geländer_1.968bec25.jpg";